import { observer } from 'mobx-react-lite'

import { PricesConfig, PriceTypesMatching, PriceTypesMatchingBaseProps } from '../PriceTypesMatching'

import { OzonAccountModel } from '../../../server/mpsklad_core/Models/OzonAccountModel'
import { OzonPriceTypesModel } from '../../../server/mpsklad_core/Models/OzonPriceTypesModel'

export const OzonPriceTypesMatching =
  observer(
    ({account, onChange}: PriceTypesMatchingBaseProps<OzonAccountModel, OzonPriceTypesModel>) =>
      <PriceTypesMatching<OzonAccountModel, OzonPriceTypesModel>
        account={account}
        pricesConfig={pricesConfig}
        initialPriceIds={{
          msBasePriceId: account.msBasePriceId,
          msMinimalPriceId: account.msMinimalPriceId,
          msPriceId: account.msPriceId
        }}
        onChange={onChange}
        onUpdateAccount={updatedPrices => {
          account.msMinimalPriceId = updatedPrices.msMinimalPriceId
        }}
      />)

const pricesConfig = {
  msBasePriceId: 'Цена Ozon без скидки',
  msMinimalPriceId: 'Цена Ozon минимальная',
  msPriceId: 'Цена Ozon'
} as const satisfies PricesConfig<OzonPriceTypesModel>